import { render, staticRenderFns } from "./premiumDetailitems.vue?vue&type=template&id=2c833e6c&scoped=true&"
import script from "./premiumDetailitems.vue?vue&type=script&lang=js&"
export * from "./premiumDetailitems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c833e6c",
  null
  
)

export default component.exports